import { getTotalSelectedTickets } from '../../containers/ticketSelection/utils/ticketUtils';
import { CheckoutState } from '../../state';
import { getSelectedTickets } from './getSelectedTickets';

export const hasSelectedTickets = (state: CheckoutState) =>
    getTotalSelectedTickets(getSelectedTickets(state)) > 0;
